class AnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.dismissKey = `rosvia-announcement-${this.dataset.dismissKey}`;
    this.dismissUntil = Number(localStorage.getItem(this.dismissKey));
    if (this.dataset.dismissible === 'true' && this.dismissUntil > Date.now()) { this.hidden = true; return; }
    if (this.dismissUntil) localStorage.removeItem(this.dismissKey);
    this.querySelector('[data-announcement-dismiss]')?.addEventListener('click', () => this.dismiss());
    this.querySelector('[data-announcement-previous]')?.addEventListener('click', () => this.showPrevious());
    this.querySelector('[data-announcement-next]')?.addEventListener('click', () => this.showNext());
    this.messages = [...this.querySelectorAll('[data-announcement-message]')];
    this.index = 0;
    this.interval = Number(this.dataset.interval || 0);
    if (this.messages.length > 1 && this.interval > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.timer = window.setInterval(() => this.showNext(), this.interval * 1000);
    }
  }
  disconnectedCallback() { window.clearInterval(this.timer); }
  showNext() {
    this.showAt(this.index + 1);
  }
  showPrevious() {
    this.showAt(this.index - 1);
  }
  showAt(index) {
    const current = this.messages[this.index];
    this.index = (index + this.messages.length) % this.messages.length;
    const next = this.messages[this.index];
    current.classList.remove('is-active');
    current.hidden = true;
    next.hidden = false;
    window.requestAnimationFrame(() => next.classList.add('is-active'));
  }
  dismiss() { localStorage.setItem(this.dismissKey, String(Date.now() + Number(this.dataset.dismissDays) * 86400000)); this.hidden = true; }
}
customElements.define('announcement-bar', AnnouncementBar);
